import { render, staticRenderFns } from "./PartEdit.vue?vue&type=template&id=6dca04f4"
import script from "./PartEdit.vue?vue&type=script&lang=js"
export * from "./PartEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports